export default __webpack_public_path__ + "static/media/facebook.46744d4a.svg";